import { render } from "./rateSettings.vue?vue&type=template&id=98d8a60a&scoped=true"
import script from "./rateSettings.vue?vue&type=script&lang=js"
export * from "./rateSettings.vue?vue&type=script&lang=js"

import "./rateSettings.vue?vue&type=style&index=0&id=98d8a60a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d8a60a"]])

export default __exports__